import { useContext } from "react";
import AuthContext from "../Context/AuthProvider";

const useAuth: any = (): any => {
  return useContext(AuthContext);
};

export default useAuth;
